/* src/app/shared-components/mb-table/mb-table.component.scss */
:host ::ng-deep .mb-table-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
:host ::ng-deep table {
  min-width: 100%;
  width: max-content;
  border-spacing: 0;
  border-collapse: collapse;
  background-color: rgb(255, 255, 255);
}
:host ::ng-deep table > thead {
  background-color: rgb(235, 241, 248);
}
:host ::ng-deep table > thead > tr {
  width: 100%;
}
:host ::ng-deep table > thead > tr > th {
  font-size: 1.2rem;
  font-weight: 600;
  text-align: left;
  padding: 1rem;
}
:host ::ng-deep table > tbody > tr {
  border-bottom: 1px solid rgb(235, 241, 248);
}
:host ::ng-deep table > tbody > tr > td {
  position: relative;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 1rem;
}
:host ::ng-deep table > tbody > tr > td > a {
  color: rgb(80, 94, 111);
}
:host ::ng-deep table > tbody > tr > td.options {
  text-align: right;
  white-space: unset;
  overflow: unset;
  text-overflow: unset;
}
:host ::ng-deep table > tbody > tr > td > span.pill {
  border: 1px solid #ebf1f8;
  padding: 0 1rem 0 1rem;
  border-radius: 10rem;
}
:host ::ng-deep table > tbody > tr > td > i.dot {
  display: block;
  width: 1rem;
  height: 1rem;
  border-radius: 1rem;
}
:host ::ng-deep table > tbody > tr.expired {
  background-color: #ffaaaa;
}
@media (max-width: 768px) {
  :host ::ng-deep table > thead > tr > th,
  :host ::ng-deep table > tbody > tr > td {
    padding: 0.75rem;
    font-size: 0.95rem;
  }
}
/*# sourceMappingURL=mb-table.component.css.map */
